"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const products_1 = __importDefault(require("@/store/ducks/products"));
const tracking_1 = __importDefault(require("@/store/ducks/tracking"));
const components_1 = __importDefault(require("@/store/ducks/components"));
const sites_1 = __importDefault(require("@/store/ducks/sites"));
const associatedComponents_1 = __importDefault(require("@/store/ducks/associatedComponents"));
const systems_1 = __importDefault(require("@/store/ducks/systems"));
const systemComponents_1 = __importDefault(require("@/store/ducks/systemComponents"));
const evaluators_1 = __importDefault(require("@/store/ducks/evaluators"));
const users_1 = __importDefault(require("@/store/ducks/users"));
const ports_1 = __importDefault(require("@/store/ducks/ports"));
const countries_1 = __importDefault(require("@/store/ducks/countries"));
const opexs_1 = __importDefault(require("./ducks/opexs"));
const approvedFeedstocks_1 = __importDefault(require("./ducks/approvedFeedstocks"));
const rootReducer = (0, toolkit_1.combineReducers)({
    products: products_1.default,
    tracking: tracking_1.default,
    components: components_1.default,
    sites: sites_1.default,
    associatedComponents: associatedComponents_1.default,
    systems: systems_1.default,
    systemComponents: systemComponents_1.default,
    evaluators: evaluators_1.default,
    users: users_1.default,
    countries: countries_1.default,
    ports: ports_1.default,
    otherCosts: opexs_1.default,
    approvedFeedstocks: approvedFeedstocks_1.default,
});
exports.default = rootReducer;
